import { useQuery } from "@tanstack/react-query";
import React from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import OurAllProjects from "../components/our-all-projects";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";

const AllProject = () => {
  const { data: banner, isLoading } = useQuery(["banner"], async () => {
    const response = await window.fetch(`${BASE_URL}/banner`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }
  return (
    <>
      <TopNavabr />
      <Header
        bannerBackground={Boolean(banner?.banner?.default) ? "video" : "image"}
        videoURL={banner?.banner?.video}
        imageURL={banner?.banner?.image}
      >
        <div className="py-5 my-5">
          <h1 className="fs-56 gilroy-bold text-center header-background-image-size">
            All Projects
          </h1>
        </div>
      </Header>
      <div className="container mt-5 pb-7">
        <OurAllProjects />
      </div>
      <Footer />
    </>
  );
};

export default AllProject;
